// Mirrors _features/roles/state/slice.js's shape. Every field from the old
// features/importsFeature/slice.js besides selectedFilters is confirmed-dead
// and dropped: `pagination`/`queryParams` (real values come from the shared
// useFilterQuery hook), `isImportsLoading`/`isFetchingImports` (real loading
// state comes from RTK Query), `openFieldMapping` (its only guard in the old
// Imports.js was permanently-true dead branching - nothing ever dispatched
// true), `openWarningModal` (destructured, never rendered, never
// dispatched), `imports` (written every fetch, never read back), and the two
// reset-everything actions (exported, never dispatched anywhere).
//
// `customColumns` also dropped from Redux, same call as User Management's
// migration (bug-sheet #109): the old hook read it from Redux only to
// immediately mirror it into a local useState via an
// initializedRef/force-reinitialize workaround - the exact dead-sync-with-
// workaround shape already diagnosed there. customColumns now lives only in
// local useState in hooks/useImportsFilters.js, same as every other migrated
// feature with real column customization.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedFilters: {
    sort: DEFAULT_SORT,
  },
};

const importsFeatureSlice = createSlice({
  name: "importsFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.importsFeature) {
        const persistedFilters = action.payload.importsFeature.selectedFilters;

        return {
          ...state,
          selectedFilters: {
            ...(persistedFilters && typeof persistedFilters === "object" ? persistedFilters : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = importsFeatureSlice.actions;

export default importsFeatureSlice.reducer;
